import React from 'react';
import { Link as LinkProps } from '../../../../../types';
import ResponsiveHeroImage from '../index';
import {
  BehaviourSettingsType as BehaviorSettings,
  generateClassNameByBehaviorSettings,
} from '../../../../../utils/behaviorSettings';
import Link from '../../../../01_atoms/Link';
import LogoWhite from '../../../../../public/static/icons/logos/logo-white.svg';

import baseStyles from '../index.module.scss';
import styles from './index.module.scss';

type HeroItem = {
  title: string;
  description: string;
};

type BBEventDetailsHeroProps = {
  logoLink: LinkProps;
  items: HeroItem[];
  heading: string;
  image: {
    small?: {
      url?: string;
      alt?: string;
    };
    medium?: {
      url?: string;
      alt?: string;
    };
    large?: {
      url?: string;
      alt?: string;
    };
  };
  behaviorSettings?: BehaviorSettings;
};

const BBEventDetailsHero = ({
  logoLink,
  items,
  heading,
  image,
  behaviorSettings,
}: BBEventDetailsHeroProps) => {
  const classes = [
    'bb',
    baseStyles['bb-hero'],
    styles['bb-event-details-hero'],
    generateClassNameByBehaviorSettings(behaviorSettings),
  ];

  return (
    <>
      <div className={classes.join(' ')} data-component={'event-details-hero'}>
        <ResponsiveHeroImage image={image} />

        {logoLink && (
          <>
            <div className={styles['bb-event-details-hero__gradient-top']} />
            <div
              className={`${styles['bb-event-details-hero__container']} ${styles['bb-event-details-hero__container--top']}`}
            >
              <div className="container">
                <div className={styles['bb-event-details-hero__site-logo']}>
                  <Link {...logoLink}>
                    <a tabIndex={0}>
                      <LogoWhite
                        alt="Concern Worldwide"
                        className={styles['bb-event-details-hero__logo-image']}
                        aria-label="Concern Worldwide"
                      />
                    </a>
                  </Link>
                </div>
              </div>
            </div>
          </>
        )}

        <div className="gradient" />
        <div
          className={`${styles['bb-event-details-hero__container']} ${styles['bb-event-details-hero__container--bottom']}`}
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h1 className="header-one rockitt" title="">
                  {heading}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      {items?.length > 0 && (
        <div className={styles['bb-event-details-hero']}>
          <div className={styles['bb-event-details-hero__items-banner']}>
            <div className="container">
              <div className={styles['bb-event-details-hero__container']}>
                <div className={styles['bb-event-details-hero__items-row']}>
                  {items.map((item, i) => (
                    <div
                      className={styles['bb-event-details-hero__item']}
                      key={`bb-event-details-hero-item-${i}`}
                    >
                      <h2 className={`${styles['bb-event-details-hero__item-title']} rockitt`}>
                        {item.title}
                      </h2>
                      <p className={`${styles['bb-event-details-hero__item-description']}`}>
                        {item.description}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BBEventDetailsHero;
